import React from "react";

type ContextType = {
    addData: (key: string, value: any) => void;
    changeData: (key: string, value: any) => void;
    resetData: () => void;
    getData: (key: string) => any;
    getAllData: () => any[];
}

export const Context = React.createContext<ContextType>({
    addData: () => {},
    changeData: () => {},
    resetData: () => {},
    getData: () => undefined,
    getAllData: () => []
});

export function Provider ({children}: {children: React.ReactNode}) {
    // const [reference, setReference] = React.useState<string[]>([]);
    // const [data, setData] = React.useState<{ [key: string]: any }>({});

    console.log("bullshit")

    function addData (key: string, value: any) {
        const ref = JSON.parse(localStorage.getItem("ref") || "[]")
        if (!ref.includes(key)) {
            const data = JSON.parse(localStorage.getItem("data") || "[]")
            localStorage.setItem("ref", JSON.stringify([...ref, key]))
            localStorage.setItem("data", JSON.stringify([...data, value || ""]))
        }
    }

    function changeData (key: string, value: any) {
        const ref: string[] = JSON.parse(localStorage.getItem("ref") || "[]")
        const data: string[] = JSON.parse(localStorage.getItem("data") || "[]")
        if (!ref.includes(key)) {
            addData(key, value)
            return
        }
        data[ref.indexOf(key)] = value
        localStorage.setItem("data", JSON.stringify(data))
    }

    function resetData () {
        localStorage.setItem("data", "[]")
        localStorage.setItem("ref", "[]")
    }

    function getData (key: string) {
        const data = JSON.parse(localStorage.getItem("data") || "[]")
        const ref = JSON.parse(localStorage.getItem("ref") || "[]")
        return data[ref.indexOf(key)]
    }

    function getAllData (): string[] {
        return JSON.parse(localStorage.getItem("data") || "[]")
    }

    return (
        <Context.Provider value={{
            addData,
            changeData,
            resetData,
            getData,
            getAllData
        }}>
            {children}
        </Context.Provider>
    )
}